import React from 'react';
import './MixTape.css';

const MixTape = (props) => {
    return (
        <div className='MixTape'>
            <h1>{props.name}</h1>
        </div>
    )
}

export default MixTape;